import { __assign } from "tslib";
// DS: I04
import React from 'react';
import IconWrap from '../IconWrap';
var PremiumFolder = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M21 7.545L19 19H5L3 7.545l5.684 4.582L12 5l3.316 7.127z" }))));
};
PremiumFolder.displayName = 'PremiumFolder';
export default PremiumFolder;
//# sourceMappingURL=PremiumFolder.js.map